const BODYLOCK_CLASSNAME = "skapa-modal-scroll-block-active";
const someCSS = 'body.skapa-modal-scroll-block-active{overflow:hidden;padding-inline-end:var(--skapa-scrollbar-width)!important}';
const tempNode = document.createElement("style");
tempNode.innerHTML = someCSS;
const lockers = /* @__PURE__ */ new WeakSet();
function lockBody(caller) {
  if (typeof window === "undefined") return;
  if (lockers.has(caller)) return;
  const body = document.body;
  body.dataset.skapaModals = (getOpenModals() + 1).toString();
  lockers.add(caller);
  if (!body.classList.contains(BODYLOCK_CLASSNAME)) {
    const beforePadding = window.getComputedStyle(body).paddingInlineEnd;
    const beforeWidth = body.clientWidth;
    body.classList.add(BODYLOCK_CLASSNAME);
    body.append(tempNode);
    const scrollbarWidth = body.clientWidth - beforeWidth;
    if (scrollbarWidth)
      caller.style.setProperty(
        "--skapa-body-scrollbar-width",
        `${scrollbarWidth}px`
      );
    body.style.setProperty(
      "--skapa-scrollbar-width",
      `calc(${scrollbarWidth}px + ${beforePadding})`
    );
  }
}
function releaseBody(caller) {
  if (!lockers.has(caller)) return false;
  const body = document.body;
  body.dataset.skapaModals = (getOpenModals() - 1).toString();
  if (getOpenModals() > 1) return false;
  lockers.delete(caller);
  if (body.classList.contains(BODYLOCK_CLASSNAME)) {
    body.classList.remove(BODYLOCK_CLASSNAME);
    body.style.removeProperty("--skapa-scrollbar-width");
    tempNode.remove();
    return true;
  }
  return true;
}
function getOpenModals() {
  return Number(document.body?.dataset.skapaModals) || 0;
}
export {
  lockBody,
  releaseBody
};
